import { faRotateLeft, faRotateRight } from "@fortawesome/pro-solid-svg-icons";
import { useIntl } from "react-intl";
import { useCabinetStore } from "../../context/StoreContext";
import FloatingButton from "../FloatingButton";

export default function HistoryState() {
	const intl = useIntl();
	const { undo, redo, undoDisabled, redoDisabled } = useCabinetStore();

	return (
		<div className="-top-2 absolute right-[calc(36px+0.5rem)] flex flex-row space-x-2 xl:static">
			<FloatingButton
				title={intl.formatMessage({ defaultMessage: "Terug" })}
				disabled={undoDisabled}
				onClick={() => undo()}
				icon={faRotateLeft}
				size="small"
			/>
			<FloatingButton
				title={intl.formatMessage({ defaultMessage: "Vooruit" })}
				disabled={redoDisabled}
				onClick={() => redo()}
				icon={faRotateRight}
				size="small"
			/>
		</div>
	);
}
